<template>
  <nuxt-link
    class="notification-panel__notification-link"
    :to="route"
    @click="markAsReadAndHandleClick"
  >
    <div class="notification-panel__notification-content-title">
      <i18n-t
        :keypath="
          approved
            ? 'rowApprovalDecisionNotification.approved'
            : 'rowApprovalDecisionNotification.changesRequested'
        "
        tag="span"
      >
        <template #approver>
          <strong>{{ approverName }}</strong>
        </template>
        <template #title>
          <strong>{{ notification.data.approval_title }}</strong>
        </template>
      </i18n-t>
    </div>
    <div
      v-if="notification.data.comment"
      class="notification-panel__notification-content-desc"
    >
      “{{ notification.data.comment }}”
    </div>
  </nuxt-link>
</template>

<script>
import notificationContent from '@baserow/modules/core/mixins/notificationContent'

export default {
  name: 'RowApprovalDecisionNotification',
  mixins: [notificationContent],
  emits: ['close-panel'],
  computed: {
    approved() {
      return this.notification.data.decision === 'approved'
    },
    approverName() {
      return (
        this.notification.data.approver_name ||
        this.$t('rowApprovalDecisionNotification.someone')
      )
    },
  },
  methods: {
    handleClick() {
      this.$emit('close-panel')
    },
  },
}
</script>
